import React from "react";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";

import { toggleCheckedTag } from "../epics/stepThreeEpics";

import { Chip, makeStyles } from "@material-ui/core";
import { CheckCircleOutline, RadioButtonUnchecked } from "@material-ui/icons";

const useStyles = makeStyles(
  () => ({
    tag: {
      backgroundColor: "transparent",
      border: "3px solid",
      color: "#424242",
      cursor: "pointer",
      margin: "4px",
      padding: 0,
      width: "fit-content"
    }
  }),
  { name: "ChipMobile" }
);

export default function ChipMobile(props) {
  const classes = useStyles();
  const { tag } = props;
  const dispatch = useDispatch();
  const checkedCardStepOne = useSelector((state) => state.checkedCardStepOne);
  const checkedCardStepTwo = useSelector((state) => state.checkedCardStepTwo);
  const checkedTags = useSelector((state) => state.checkedTags);

  const selected = React.useMemo(
    () => _.includes(checkedTags[checkedCardStepOne + " " + checkedCardStepTwo], tag.value),
    [checkedCardStepOne, checkedCardStepTwo, tag.value, checkedTags]
  );

  const handleToggleSelectedTag = (tag) => {
    dispatch(toggleCheckedTag(checkedCardStepOne + " " + checkedCardStepTwo, tag.value));
  };

  return (
    <Chip
      key={tag.value}
      label={tag.value}
      style={{ borderColor: tag.color, backgroundColor: "white", color: tag.color }}
      className={classes.tag}
      onDelete={() => handleToggleSelectedTag(tag)}
      deleteIcon={selected ? <CheckCircleOutline /> : <RadioButtonUnchecked />}
      onClick={() => handleToggleSelectedTag(tag)}
    />
  );
}
